import React from 'react';
import { Helmet } from 'react-helmet';
import Title from '../../../components/Title';
import PageNavigation from './PageNavigation';
import { Outlet } from 'react-router-dom';

export default function NotificationsSettingsPage() {
    return (
        <div>
            <Helmet>
                <title>Console Defentry - Settings - Notifications</title>
            </Helmet>
            <Title
                subText="Please fill information for each type of notifications"
                isSubPageTitle
            >
                Notifications
            </Title>
            <div className="navigation-tabs__bottom-indent-wrapper--24">
                <PageNavigation />
            </div>
            <Outlet />
        </div>
    );
}
